var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlyConfidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 0.666748L0.333008 4.66675V12.7867C0.333008 19.5201 4.87967 25.8001 10.9997 27.3334C17.1197 25.8001 21.6663 19.5201 21.6663 12.7867V4.66675L10.9997 0.666748ZM18.9997 12.7867C18.9997 18.1201 15.5997 23.0534 10.9997 24.5601C6.39967 23.0534 2.99967 18.1334 2.99967 12.7867V6.52008L10.9997 3.52008L18.9997 6.52008V12.7867Z",
    fill: "#FF7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.333008 4.66675L10.9997 0.666748L21.6663 4.66675V12.7867C21.6663 15.9279 20.6769 18.9703 18.9998 21.4783V16.6668C18.9998 14.9251 17.8867 13.4435 16.3331 12.8944V11.3334C16.3331 8.38791 13.9453 6.0001 10.9998 6.0001C8.05429 6.0001 5.66647 8.38791 5.66647 11.3334V12.8944C4.11288 13.4435 2.9998 14.9251 2.9998 16.6668V21.4786C1.32258 18.9706 0.333008 15.928 0.333008 12.7867V4.66675Z",
    fill: "#FF7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7453 26.0001C8.76184 26.5923 9.85315 27.0462 10.9997 27.3334C12.1462 27.0462 13.2375 26.5923 14.2541 26.0001H7.7453Z",
    fill: "#FF7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 8.66676C9.52705 8.66676 8.33314 9.86067 8.33314 11.3334V12.6668H13.6665V11.3334C13.6665 9.86067 12.4726 8.66676 10.9998 8.66676Z",
    fill: "#FF7A7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6666 16.6668C9.6666 15.9304 10.2636 15.3334 10.9999 15.3334C11.7363 15.3334 12.3333 15.9304 12.3333 16.6668V19.3334C12.3333 20.0698 11.7363 20.6668 10.9999 20.6668C10.2636 20.6668 9.6666 20.0698 9.6666 19.3334V16.6668Z",
    fill: "#FF7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlyConfidential);
export default __webpack_public_path__ + "static/media/highly-confidential.d8c7a09cd215c79df2fa99e17217d89d.svg";
export { ForwardRef as ReactComponent };